/* 注册页面专用样式 */

/* 密码强度指示器 */
.password-strength {
  margin-top: 6px;
  height: 4px;
  border-radius: 2px;
  background: #2c2c2c;
  overflow: hidden;
}

.password-strength-bar {
  height: 100%;
  transition: width 0.3s ease, background-color 0.3s ease;
}

.strength-weak {
  width: 33%;
  background-color: #ff4757;
}

.strength-medium {
  width: 66%;
  background-color: #ffa502;
}

.strength-strong {
  width: 100%;
  background-color: #2ed573;
}

/* 密码匹配指示器 */
.password-match {
  font-size: 0.8rem;
  margin-top: 6px;
  transition: color 0.3s ease;
}

.password-match.match {
  color: #2ed573;
}

.password-match.no-match {
  color: #ff4757;
}

/* 注册页保持单一任务主线：账号信息 -> 验证码 -> 注册 */
.register-gate {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  background:
    radial-gradient(circle at 50% -12%, rgba(26, 115, 232, 0.13), transparent 34rem),
    linear-gradient(180deg, #f7faff 0%, #ffffff 58%, #f8fbff 100%) !important;
}

.register-gate .access-gate-container {
  height: auto !important;
  min-height: 100vh !important;
  min-height: 100dvh !important;
  justify-content: center !important;
  padding: clamp(20px, 4vh, 44px) 0 !important;
  gap: 0 !important;
}

.register-gate .gate-container {
  width: 100% !important;
  max-width: 440px !important;
}

.register-gate .gate-logo-container {
  margin-bottom: 14px !important;
}

.register-gate .gate-logo .logo {
  font-size: clamp(2rem, 7vw, 2.65rem) !important;
  letter-spacing: clamp(3px, 1vw, 5px) !important;
}

.register-gate .gate-tagline {
  margin-top: 0 !important;
  font-size: 0.88rem !important;
  color: #718096 !important;
}

.register-gate .gate-card {
  border-color: #dfe7f1 !important;
  border-radius: 22px !important;
  box-shadow: 0 18px 50px rgba(37, 69, 116, 0.11), 0 2px 8px rgba(37, 69, 116, 0.04) !important;
}

.register-gate .gate-card-inner {
  padding: 26px 30px 22px !important;
}

.register-gate .gate-header {
  margin-bottom: 18px !important;
  text-align: center;
}

.register-gate .gate-header h2 {
  margin-bottom: 5px !important;
  color: #172033 !important;
  font-size: 1.65rem !important;
  font-weight: 700 !important;
}

.register-gate .gate-header p {
  color: #7a8493 !important;
  font-size: 0.83rem !important;
}

.register-gate .gate-form {
  margin-bottom: 0 !important;
}

.register-gate .form-group {
  margin-bottom: 14px !important;
}

.register-gate .form-group label {
  margin-bottom: 6px !important;
  color: #445064 !important;
  font-size: 0.8rem !important;
  font-weight: 600 !important;
}

.register-gate .form-input {
  min-height: 46px !important;
  padding: 10px 13px !important;
  color: #172033 !important;
  background: #f8faff !important;
  border-color: #dbe3ee !important;
  border-radius: 11px !important;
}

.register-gate .form-input:hover:not(:disabled) {
  border-color: #b9c8dc !important;
}

.register-gate .input-with-button {
  gap: 9px;
}

.register-gate .send-code-btn {
  min-width: 104px;
  padding: 0 14px;
  background: #eef5ff !important;
  color: #1769d2 !important;
  border-color: #cfe1fb !important;
  box-shadow: none !important;
  font-weight: 600;
}

.register-gate .send-code-btn:hover:not(:disabled) {
  color: #fff !important;
  background: #1769d2 !important;
  border-color: #1769d2 !important;
}

.register-gate .password-strength {
  height: 3px;
  margin-top: 6px;
  background: #e8edf4;
}

.register-gate .password-strength-text,
.register-gate .password-match,
.register-gate .code-hint {
  margin-top: 5px;
  font-size: 0.72rem;
}

.register-gate .key-submit {
  min-height: 48px !important;
  margin-top: 4px !important;
  background: #1a73e8 !important;
  box-shadow: 0 2px 8px rgba(26, 115, 232, 0.24) !important;
  border-color: #1769d2 !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 24px rgba(23, 105, 210, 0.22) !important;
  font-size: 0.98rem !important;
}

.register-gate .key-submit:hover:not(:disabled) {
  background: #1557b0 !important;
  box-shadow: 0 12px 28px rgba(23, 105, 210, 0.28) !important;
}

.register-gate .gate-footer {
  margin-top: 15px !important;
  padding-top: 14px !important;
  border-top-color: #edf1f6 !important;
  font-size: 0.82rem !important;
}

.register-gate .auth-success,
.register-gate .auth-error {
  margin-bottom: 13px;
  padding: 9px 11px;
  text-align: left;
  font-size: 0.78rem;
  line-height: 1.45;
}

@media (max-width: 600px) {
  .register-gate .access-gate-container {
    justify-content: flex-start !important;
    padding: 18px 0 22px !important;
  }

  .register-gate .gate-container {
    padding: 0 14px !important;
  }

  .register-gate .gate-logo-container {
    margin-bottom: 12px !important;
  }

  .register-gate .gate-logo .logo {
    font-size: 2rem !important;
  }

  .register-gate .gate-card {
    border-radius: 18px !important;
  }

  .register-gate .gate-card-inner {
    padding: 22px 18px 18px !important;
  }

  .register-gate .gate-header {
    margin-bottom: 16px !important;
  }

  .register-gate .gate-header h2 {
    font-size: 1.45rem !important;
  }

  .register-gate .form-group {
    margin-bottom: 12px !important;
  }

  .register-gate .form-input {
    min-height: 44px !important;
  }

  .register-gate .send-code-btn {
    min-width: 96px;
    padding: 0 11px;
    font-size: 0.78rem;
  }
}

@media (max-width: 370px) {
  .register-gate .input-with-button {
    flex-direction: column;
  }

  .register-gate .send-code-btn {
    min-height: 42px;
  }
}
